import React from 'react';
import ExpandableHeader from './ExpandableHeader';

interface ExpandableProps {
  title: string;
  menu: JSX.Element;
  headerClassName?: string;
}

interface ExpandableState {
  isOpen: boolean;
}

export default class Expandable extends React.Component<ExpandableProps, ExpandableState> {
  constructor(props: ExpandableProps) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  render() {
    const show = this.state.isOpen;
    return (
      <div className="expandable">
        <div className={this.props.headerClassName} onClick={this._toggle}>
          {!show && <ExpandableHeader isOpen={false} title={this.props.title} />}
          {show && <ExpandableHeader isOpen={true} title={this.props.title} />}
        </div>
        {show && <div className="menu">{this.props.menu}</div>}
      </div>
    );
  }

  private _toggle = () => this.setState({ isOpen: !this.state.isOpen });
}
